export default "__VITE_ASSET__24709355__"